import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginSelectionComponent } from './accounts/login-selection/login-selection.component';

const routes: Routes = [
  {path: 'auth', loadChildren: () => import('./accounts/accounts.module').then(m => m.AccountsModule) },
  {path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {path:'',loadChildren: () => import('./oo-pages/oo-pages.module').then(m => m.OoPagesModule)},
  {path: 'login-selection', component: LoginSelectionComponent }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
